import { IncidentSubmittability } from "../../lib/rules/incidentSubmittability"
import { IncidentModel } from "../reduxToolkit/incidentsSlice"
import {
  evaluateIncidentSubmittabilityFor,
  selectIncidentSubmittability,
} from "../reduxToolkit/selectors/incidentSubmittability"
import { useAppSelector } from "./reduxToolkit"

/**
 * Whether this incident can be submitted, and if not, why not.
 *
 * This is the hook the React Native SDK exposes so partners can drive their own
 * submit affordance. It reads current state rather than waiting on a todo to
 * arrive from the backend, which is what lets todo generation live entirely on
 * the server -- see docs/plans/embeddable-sdk.md.
 *
 * Returns null when the incident isn't in the store.
 */
export function useIncidentSubmittability(incidentId: string): IncidentSubmittability | null {
  return useAppSelector(selectIncidentSubmittability(incidentId))
}

/**
 * The same rule for callers that already hold the incident (the common case in
 * components rendered per-incident), avoiding a redundant lookup by id.
 */
export function useIncidentSubmittabilityFor(incident: IncidentModel): IncidentSubmittability {
  return useAppSelector((s) => evaluateIncidentSubmittabilityFor(s, incident))
}
